var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center ads-circle-icon",style:({
    'background-color': _vm.backgroundColor,
    'border-radius': '50%',
    width: _vm.computedSize,
    height: _vm.computedSize,
    'font-size': _vm.computedFontSize,
    color: _vm.color,
  })},[_vm._t("icon",function(){return [_c('v-icon',{style:({ color: _vm.color }),attrs:{"size":_vm.computedIconSize}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }